// Every flow route the portal calls; http is the SfpInstance (or a fake in the tests).
const order = id => `orders/${encodeURIComponent(id)}`

export const createSfpApi = http => ({
  me: () => http.get('me'),
  listOrders: params => http.get('orders', { params }),
  getOrder: id => http.get(order(id)),
  exportOrders: params => http.get('orders/export', { params, responseType: 'blob' }),
  listRejectReasons: () => http.get('reject-reasons'),
  listAddresses: supplierId => http.get(`suppliers/${supplierId}/addresses`),
  addGrant: (supplierId, body) => http.post(`suppliers/${supplierId}/grants`, body),
  accept: id => http.post(`${order(id)}/accept`),
  reject: (id, body) => http.post(`${order(id)}/reject`, body),
  cancelAck: id => http.post(`${order(id)}/cancel-ack`),
  collect: (id, body) => http.post(`${order(id)}/collect`, body),
  collectBulk: orders => http.post('orders/collect', { orders }),
  revertCollect: id => http.post(`${order(id)}/collect/revert`),
  retryDispatch: id => http.post(`${order(id)}/dispatch/retry`),
  reprintLabels: id => http.post(`${order(id)}/labels/reprint`),
  uploadProof: (id, form) => http.post(`${order(id)}/assets`, form),
  markDelivered: (id, body) => http.post(`${order(id)}/delivery`, body)
})



// WEBPACK FOOTER //
// ./src/sfp/api.js